import React from "react";
import PropTypes from 'prop-types';

const EquipeClassement = ({ equipe, classement }) => {
    const statut = equipe.statut;

    const bgClass = statut === 'qualifié'
        ? 'bg-green-900/20 border-green-900/40 hover:border-green-700/60'
        : statut === 'éliminé'
        ? 'bg-red-900/20 border-red-900/40 hover:border-red-700/60'
        : 'bg-[#1A1A1A] bg-opacity-70 border-gray-700 hover:border-gray-500';

    return (
        <div className={`rounded-lg p-4 backdrop-blur-sm border transition-all ${bgClass}`}>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 md:gap-4 min-w-[32px] md:min-w-[60px]">
                    <span className="text-base md:text-lg font-bold text-white">{classement}</span>
                </div>

                <div className="flex-1 flex items-center gap-2 md:gap-4 min-w-0">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/equipes/${equipe.logo}`}
                        alt={equipe.name}
                        className="w-8 h-8 md:w-12 md:h-12 rounded-md object-contain flex-shrink-0"
                        onError={(e) => e.target.style.display = 'none'}
                    />
                    <div className="text-left min-w-0">
                        <p className="font-semibold text-white text-sm md:text-lg truncate">{equipe.name}</p>
                        <p className="text-xs text-gray-400">{equipe.teamtag}</p>
                    </div>
                </div>

                <div className="flex items-center gap-3 md:gap-6 min-w-[80px] md:min-w-[140px]">
                    <div className="text-right flex items-center gap-1">
                        <p className="text-lg md:text-2xl font-bold text-green-400">{equipe.wins}</p>
                        <p className="text-xs md:text-sm font-bold text-green-400">W</p>
                    </div>
                    <span className="text-gray-600">-</span>
                    <div className="text-left flex items-center gap-1">
                        <p className="text-lg md:text-2xl font-bold text-red-400">{equipe.losses}</p>
                        <p className="text-xs md:text-sm font-bold text-red-400">L</p>
                    </div>
                    <p className={`text-xs md:text-sm font-semibold ${equipe.gamePoints > 0 ? 'text-gray-300' : equipe.gamePoints < 0 ? 'text-gray-500' : 'text-gray-500'}`}>
                        {equipe.gamePoints > 0 ? `+${equipe.gamePoints}` : equipe.gamePoints}
                    </p>
                </div>
            </div>
        </div>
    );
};

EquipeClassement.propTypes = {
    equipe: PropTypes.object.isRequired,
    classement: PropTypes.number.isRequired,
};

export default EquipeClassement;
